import { render, staticRenderFns } from "./SearchCarousel.vue?vue&type=template&id=304f9b7c&"
import script from "./SearchCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304f9b7c')) {
      api.createRecord('304f9b7c', component.options)
    } else {
      api.reload('304f9b7c', component.options)
    }
    module.hot.accept("./SearchCarousel.vue?vue&type=template&id=304f9b7c&", function () {
      api.rerender('304f9b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JVRjTY8s7QsL/JS/SearchCarousel.vue"
export default component.exports